export default __webpack_public_path__ + "static/media/background.050d21b0.jpg";